export const siteInfo = {
  name: "年轻的母亲2",
  tagline: "专业电视剧内容聚合平台",
  intro:
    "本站是围绕电视剧《年轻的母亲2》打造的专业内容聚合平台，面向家庭剧爱好者、追剧用户与影视内容研究者，提供逐集剧情解析、角色深度分析与最新影视资讯。我们希望用结构清晰、信息详实的内容，帮助每一位观众更好地理解剧情进展与人物关系。",
  contactEmail: "hello@youngmother2.example.com",
  carousel: [
    {
      id: "ep-10",
      title: "雨夜和解",
      subtitle: "第10集 · 两个女人终于说出积压多年的话",
      desc: "暴雨切断了供电，家里点起蜡烛。没有电视的噪音，林慧和婆婆第一次面对面坐下来，把话一点点说完。",
      image:
        "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20two%20chinese%20women%20sitting%20face%20to%20face%20by%20warm%20candlelight%20during%20a%20rainy%20night%20power%20outage%2C%20dark%20moody%20interior%20with%20soft%20orange%20glow%2C%20intimate%20quiet%20emotional%20atmosphere%2C%20shot%20on%20film%20with%20grain&width=1600&height=900&seq=ym2-hero01&orientation=landscape",
    },
    {
      id: "ep-01",
      title: "搬家之后",
      subtitle: "第1集 · 一个重组家庭在老城区的第一天",
      desc: "林慧抱着熟睡的女儿站在老式居民楼下，堆满纸箱的新家里，藏着期待也藏着不安。",
      image:
        "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20young%20chinese%20mother%20carrying%20sleeping%20child%20in%20front%20of%20old%20residential%20building%20with%20moving%20boxes%2C%20golden%20late%20afternoon%20light%2C%20warm%20nostalgic%20tones%2C%20shot%20on%20film%20with%20grain&width=1600&height=900&seq=ym2-hero02&orientation=landscape",
    },
    {
      id: "ep-16",
      title: "阳光正好",
      subtitle: "第16集 · 第一季大结局：日子过成了想要的样子",
      desc: "清晨的阳光穿过老楼的树影，落在新粉刷的墙面上。这个普通的家庭，终于走向属于自己的光。",
      image:
        "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20sunny%20morning%20light%20through%20tree%20shadows%20on%20an%20old%20residential%20balcony%20with%20green%20plants%20and%20freshly%20painted%20wall%2C%20warm%20hopeful%20golden%20tones%2C%20shot%20on%20film%20with%20grain&width=1600&height=900&seq=ym2-hero03&orientation=landscape",
    },
  ],
};